import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const THRESHOLD_EVENT_TYPE = "defect_threshold_exceeded";

export const EVENT_TYPE_LABELS = {
  file_upload: "File Upload",
  rerank: "Re-rank",
  config_change: "Configuration Change",
  status_update: "Status Update",
  spec_restored: "Spec Restored",
  assignee_changed: "Assignee Changed",
  [THRESHOLD_EVENT_TYPE]: "Defect Threshold Exceeded",
};

// Maps a raw /notifications-api/list row into the shape the notification
// UI (bell, table, detail modal) renders. Threshold-exceeded events carry
// per-spec defect metrics; every other event type only has a summary.
export function mapNotificationRow(row) {
  const details = row?.details || {};
  const specs = details.specs || [];
  const first = specs[0] || {};
  const isThreshold = row.event_type === THRESHOLD_EVENT_TYPE;

  const currentRate = first.current_rate;
  const baselineRate = first.baseline_rate;
  const thresholdPct = details.threshold_pct;
  const exceedPct =
    isThreshold && baselineRate ? ((currentRate - baselineRate) / baselineRate) * 100 : 0;

  return {
    id: row.id,
    eventType: row.event_type,
    eventTypeLabel: EVENT_TYPE_LABELS[row.event_type] || row.event_type,
    isThreshold,
    audience: row.audience,
    actor: row.actor_username,
    flightModelId: row.flight_model_id,
    flightModel: details.flight_model || "—",
    spec: first.spec_concat || "—",
    cardNo: first.card_no || "—",
    taskDescription: first.task_description || "",
    message: row.summary,
    defectCount: isThreshold ? first.defect_count : undefined,
    currentRate: isThreshold ? currentRate : undefined,
    baselineRate: isThreshold ? baselineRate : undefined,
    thresholdPct: isThreshold ? thresholdPct : undefined,
    severity: isThreshold
      ? exceedPct >= Number(thresholdPct || 0) * 1.5
        ? "critical"
        : "warning"
      : "info",
    specs,
    details,
    timestamp: formatRelativeTime(row.created_at),
    date: row.created_at,
    read: !!row.is_read,
  };
}

export function formatRelativeTime(iso) {
  if (!iso) return "";
  return dayjs(iso).fromNow();
}
